import { render, staticRenderFns } from "./producer.vue?vue&type=template&id=113cc4a7&scoped=true"
import script from "./producer.vue?vue&type=script&lang=js"
export * from "./producer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113cc4a7",
  null
  
)

export default component.exports